import {
  type AEvent,
  createTrackingEmitterHooks,
  type EventTransformerHooks,
} from "@b2bportal/core-tracking";

export type PackagesRawEvent =
  | PackageAppLoadedRawEvent
  | PackageSearchLoadedRawEvent
  | PackageHotelAvailabilityPageLoadedRawEvent
  | PackageHotelUpdatedListPageRawEvent
  | PackageHotelShopPageLoadedRawEvent
  | PackageSelectedFlightOutboundRawEvent
  | PackageSelectedFlightReturnRawEvent
  | PackageReviewDetailsLoadedRawEvent;

export enum PackagesRawEventName {
  PackageAppLoaded = "PackageAppLoaded",
  PackageSearchLoaded = "PackageSearchLoaded",
  PackageHotelAvailabilityPageLoaded = "PackageHotelAvailabilityPageLoaded",
  PackageHotelUpdatedListPage = "PackageHotelUpdatedListPage",
  PackageHotelShopPageLoaded = "PackageHotelShopPageLoaded",
  PackageSelectedFlightOutbound = "PackageSelectedFlightOutbound",
  PackageSelectedFlightReturn = "PackageSelectedFlightReturn",
  PackageReviewDetailsLoaded = "PackageReviewDetailsLoaded",
}

export type PackageAppLoadedRawEvent = {
  name: PackagesRawEventName.PackageAppLoaded;
  properties: {
    entry: string;
  };
};

export type PackageSearchLoadedRawEvent = {
  name: PackagesRawEventName.PackageSearchLoaded;
};

export type PackageHotelAvailabilityPageLoadedRawEvent = {
  name: PackagesRawEventName.PackageHotelAvailabilityPageLoaded;
  properties: {
    pageIndex: number;
    pagePropertyCount: number;
  };
};

export type PackageHotelUpdatedListPageRawEvent = {
  name: PackagesRawEventName.PackageHotelUpdatedListPage;
  properties: {
    pageIndex: number;
    pagePropertyCount: number;
  };
};

export type PackageHotelShopPageLoadedRawEvent = {
  name: PackagesRawEventName.PackageHotelShopPageLoaded;
};

export type PackageSelectedFlightOutboundRawEvent = {
  name: PackagesRawEventName.PackageSelectedFlightOutbound;
  properties?: {
    fareClass?: string;
    cityPair?: string;
    tripType?: string;
  };
};

export type PackageSelectedFlightReturnRawEvent = {
  name: PackagesRawEventName.PackageSelectedFlightReturn;
  properties?: {
    fareClass?: string;
    cityPair?: string;
    tripType?: string;
  };
};

export type PackageReviewDetailsLoadedRawEvent = {
  name: PackagesRawEventName.PackageReviewDetailsLoaded;
  properties?: {
    fareClass?: string;
    cityPair?: string;
    tripType?: string;
  };
};

export const {
  useEmitRawEvent: useEmitCorePackagesRawEvent,
  useEmitRawEventOnce: useEmitCorePackagesRawEventOnce,
} = createTrackingEmitterHooks<PackagesRawEvent>();

export type TransformerHooks = EventTransformerHooks<PackagesRawEvent, AEvent>;
